import { format, lastDayOfMonth } from 'date-fns'

const today = new Date()
export const lastDateOfMonth = format(lastDayOfMonth(today), 'yyyy-MM-dd')
